import { render, staticRenderFns } from "./BuildingPortalLinksTab.vue?vue&type=template&id=3d59307e&scoped=true"
import script from "./BuildingPortalLinksTab.vue?vue&type=script&lang=ts"
export * from "./BuildingPortalLinksTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d59307e",
  null
  
)

export default component.exports